/* unplugin-vue-components disabled */import { render } from "./UpdateAuthorization.vue?vue&type=template&id=3ebe4136"
import script from "./UpdateAuthorization.vue?vue&type=script&lang=js"
export * from "./UpdateAuthorization.vue?vue&type=script&lang=js"

import "./UpdateAuthorization.vue?vue&type=style&index=0&id=3ebe4136&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__